export default "__VITE_ASSET__CMvG$KQh__"